module.exports = __webpack_public_path__ + "img/ppt-icon.d35cf3bc.png";